import EditIcon from '@mui/icons-material/Edit';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import { Box, Button, Typography } from '@mui/material';
import Monaco from '../monaco/index.js';
import Widget from '../widget.js';
import type { GraphQLProps } from './graphql-hook.js';

export const GraphQL = (props: GraphQLProps) => {
  const { id, label, visible, initialValue, prettify, monacoInstanceRef, editorInstanceRef, error, handleShow } = props;

  // Do not initialize Monaco until initial value is ready
  if (initialValue === null) {
    return null;
  }

  let content;
  if (!visible) {
    content = (
      <Widget {...props} error={props.error ? props.error : undefined}>
        <Button variant="contained" size="small" startIcon={<EditIcon />} onClick={handleShow}>
          {label}
        </Button>
      </Widget>
    );
  } else {
    content = (
      <>
        <Monaco
          {...props}
          error={undefined}
          value={initialValue}
          monacoLanguage="graphql"
          monacoInstanceRef={monacoInstanceRef}
          editorInstanceRef={editorInstanceRef}
          resizable
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box>{error ? <Typography sx={{ color: 'error.main' }}>{error}</Typography> : null}</Box>
          <Box>
            <Button variant="text" size="small" startIcon={<FormatPaintIcon />} onClick={prettify}>
              Prettify
            </Button>
          </Box>
        </Box>
      </>
    );
  }

  return <Box data-testid={id}>{content}</Box>;
};
